// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Rzgg","largestCol":"styles_largestCol__1_zn7","smallestCol":"styles_smallestCol__1LRsS"};